import { render, staticRenderFns } from "./ReportFrequency.vue?vue&type=template&id=46a71078"
import script from "./ReportFrequency.vue?vue&type=script&lang=js"
export * from "./ReportFrequency.vue?vue&type=script&lang=js"
import style0 from "./ReportFrequency.vue?vue&type=style&index=0&id=46a71078&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports